<div class="wrapper-page-about">
  <div class="bg-about-page"> </div>
  <div class="zc-container">
    <div class="grid">
      <div class="grid__l-6">
        <div class="wrapper-description-about">
          <span class="title-about-page">O nama</span>
          <span class="description-about-page">

Dobrodošli u Moj Rođendan – prvu aplikaciju koja omogućava roditeljima da na jednom mestu organizuju kompletan dečiji rođendan! 🎉<br>
Naša misija je da planiranje proslava učinimo jednostavnim, brzim i bez stresa – bez poziva i dogovora, već kroz samo nekoliko klikova.
<br>
U aplikaciji možete rezervisati sve što vam je potrebno: 🏰 igraonice, 🍕 ketering, 🎂 torte, 🪄 animatore, 🎀 dekoracije i 📸 fotografe.
<br>
Pored vaše organizacije, Moj Rođendan donosi i listu želja poklona, kako bi gosti tačno znali šta dete želi. Pokloni se kupuju direktno iz aplikacije, po istim maloprodajnim cenama kao u radnjama i bez lutanja. Sve rezervacije i kupovine potvrđuju se automatski, a i roditelji i partneri odmah dobijaju sve detalje o terminu i plaćanju.
<br>
Pridružite nam se i učinite svaki rođendan magičnim, jednostavnim i nezaboravnim! <br>
📱 Dostupno na App Store i Google Play.
          </span>
          <div class="wrapper-logo-about">
            <img src="../../../../assets/images/landing/logo-about-page.svg" alt="">
          </div>
        </div>
      </div>
      <div class="grid__l-6">
        <!-- Photo Grid -->
        <div class="gallery">
          <figure *ngFor="let image of gallery; index as imageIndex" (click)="handleShowCarousel(imageIndex)">
            <img [src]="image.full_path" alt="">
          </figure>
        </div>
      </div>
      <div *ngIf="showCarousel" class="wrapper-carousel-slider">
        <div class="wrapper-content-carousel-slider">
          <div class="wrapper-btn-carousel-close">
            <button class="btn-carousel-close" (click)="showCarousel = false">
              <span>Zatvori</span>
              <img src="../../../../assets/icons/landing/icon-close.svg" alt="">
            </button>
          </div>
          <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slideConfig">
            <div ngxSlickItem *ngFor="let slide of gallery" class="slide">
              <img src="{{ slide.full_path }}" alt="slide">
            </div>
          </ngx-slick-carousel>
          <div (click)="slickModal.slickPrev()" class="wrapper-arrow-prev">
            <img src="../../../../assets/icons/landing/icon-arrow-left-slider.svg" alt="">
          </div>
          <div (click)="slickModal.slickNext()" class="wrapper-arrow-next">
            <img src="../../../../assets/icons/landing/icon-arrow-right-slider.svg" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
